/**
 * Invoice Ninja (https://invoiceninja.com).
 *
 * @link https://github.com/invoiceninja/invoiceninja source repository
 *
 * @copyright Copyright (c) 2022. Invoice Ninja LLC (https://invoiceninja.com)
 *
 * @license https://www.elastic.co/licensing/elastic-license
 */

export const enum PurchaseOrderStatus {
  Viewed = '-1',
  Draft = '1',
  Sent = '2',
  Accepted = '3',
  Received = '4',
  Cancelled = '5',
}
